import { render } from "./CouponSaveTierPage.vue?vue&type=template&id=76bde63c"
import script from "./CouponSaveTierPage.vue?vue&type=script&lang=js"
export * from "./CouponSaveTierPage.vue?vue&type=script&lang=js"
script.render = render

export default script